module.exports = __webpack_public_path__ + "img/drive-vil-2.d05fdc18.svg";